import { useState, useEffect, useCallback } from 'react';

function useWindowSize(debounceDelay: number = 100) {
  const getSize = () => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  const [windowSize, setWindowSize] = useState(getSize);

  const debounce = (fn: () => void, ms: number) => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    return (...args: any[]) => {
      clearTimeout(timer!);
      timer = setTimeout(() => {
        timer = null;
        fn();
      }, ms);
    };
  };

  const handleResize = useCallback(() => {
    const handleResizeDebounced = debounce(() => {
      setWindowSize(getSize());
    }, debounceDelay);
    handleResizeDebounced();
  }, [debounceDelay]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [handleResize]);

  return windowSize;
}

export { useWindowSize };
